<div class="eui-timepicker" [class.eui-timepicker--centered]="isDatetimepicker">
    <div class="eui-timepicker__input-container">
        <a class="eui-timepicker__chevron" tabindex="-1">
            <span class="eui-icon eui-icon-fw eui-icon-chevron-up" aria-label="Increase Hours" (click)="changeHour(1)"></span>
        </a>
        <input #inputrefhours
            type="number"
            class="eui-timepicker__input"
            max="23"
            min="00"
            placeholder="HH"
            [value]="formatHour(hours)"
            (change)="updateHour($event.target.value)"
            [readOnly]="isreadOnly"
            aria-label="Hours"
            (keypress)="restrictHoursLength(inputrefhours)"
            (keydown.ArrowUp)="changeHour(1); $event.preventDefault()"
            (keydown.ArrowDown)="changeHour(-1); $event.preventDefault()">
        <a tabindex="-1" class="eui-timepicker__chevron">
            <span class="eui-icon eui-icon-fw eui-icon-chevron-down" aria-label="Decrease Hours" (click)="changeHour(-1)"></span>
        </a>
    </div>
    <div class="eui-timepicker__spacer">:</div>
    <div class="eui-timepicker__input-container">
        <a tabindex="-1" class="eui-timepicker__chevron">
            <span class="eui-icon eui-icon-fw eui-icon-chevron-up" aria-label="Increase Minutes"  (click)="changeMinutes(1)"></span>
        </a>
        <input #inputrefmins
            type="number"
            max="59"
            min="00"
            class="eui-timepicker__input"
            placeholder="MM"
            [value]="formatMins(mins)"
            (change)="updateMinutes($event.target.value)"
            [readOnly]="isreadOnly"
            aria-label="Minutes"
            (keypress)="restrictMinsLength(inputrefmins)"
            (keydown.ArrowUp)="changeMinutes(1); $event.preventDefault()"
            (keydown.ArrowDown)="changeMinutes(-1); $event.preventDefault()">
        <a tabindex="-1" class="eui-timepicker__chevron">
            <span class="eui-icon eui-icon-fw eui-icon-chevron-down" aria-label="Decrease Minutes" (click)="changeMinutes(-1)"></span>
        </a>
    </div>
    <ng-container *ngIf="hasSeconds">
        <div class="eui-timepicker__spacer">:</div>
        <div class="eui-timepicker__input-container">
            <a tabindex="-1" class="eui-timepicker__chevron">
                <span class="eui-icon eui-icon-fw eui-icon-chevron-up" aria-label="Increase Seconds"  (click)="changeSeconds(1)"></span>
            </a>
            <input #inputrefsecs
                type="number"
                max="59"
                min="00"
                class="eui-timepicker__input"
                placeholder="SS"
                [value]="formatSecs(secs)"
                (change)="updateSeconds($event.target.value)"
                [readOnly]="isreadOnly"
                aria-label="Seconds"
                (keypress)="restrictSecsLength(inputrefsecs)"
                (keydown.ArrowUp)="changeSeconds(1); $event.preventDefault()"
                (keydown.ArrowDown)="changeSeconds(-1); $event.preventDefault()">
            <a tabindex="-1" class="eui-timepicker__chevron">
                <span class="eui-icon eui-icon-fw eui-icon-chevron-down" aria-label="Decrease Seconds" (click)="changeSeconds(-1)"></span>
            </a>
        </div>
    </ng-container>
</div>
